module.exports = __webpack_public_path__ + "img/10.6.CODm.a5308e0a.png";